import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { ROUTES } from '@/constants';

import { AUTH_ERROR_EVENT } from './ApolloClientProvider/auth-error-link';

const AUTH_FLOW_PATHS: string[] = [ROUTES.login, ROUTES.logout, ROUTES.authComplete];

// Listens for the global auth-error event dispatched by the Apollo authErrorLink
// when any GraphQL operation returns an OperationError with code 401, and routes
// the user through /logout (which clears Apollo cache and sends them to /login).
const AuthErrorWatcher: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const pathnameRef = useRef(pathname);
  pathnameRef.current = pathname;

  useEffect(() => {
    const onAuthError = () => {
      const path = pathnameRef.current;
      if (AUTH_FLOW_PATHS.includes(path)) return;
      navigate(ROUTES.logout, { state: { referrer: path } });
    };
    window.addEventListener(AUTH_ERROR_EVENT, onAuthError);
    return () => window.removeEventListener(AUTH_ERROR_EVENT, onAuthError);
  }, [navigate]);

  return null;
};

export default AuthErrorWatcher;
